import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { clubApi } from "../../club-api-client";
import type { SetAvailability } from "../../types";
import { queryKeys } from "../query-keys";

export function useSeasonAvailability(clubId: string | null, seasonId: string | null) {
	return useQuery({
		queryKey: queryKeys.clubPortal.trainingAvailability(clubId ?? "", seasonId ?? ""),
		queryFn: () => clubApi.training.availability.list(clubId!, seasonId!),
		enabled: !!clubId && !!seasonId,
	});
}

export function useMyAvailability(clubId: string | null, seasonId: string | null) {
	return useQuery({
		queryKey: queryKeys.clubPortal.trainingMyAvailability(clubId ?? "", seasonId ?? ""),
		queryFn: () => clubApi.training.availability.me(clubId!, seasonId!),
		enabled: !!clubId && !!seasonId,
	});
}

export function useSetMyAvailability(clubId: string) {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: ({ seasonId, data }: { seasonId: string; data: SetAvailability }) =>
			clubApi.training.availability.setMine(clubId, seasonId, data),
		onSuccess: () =>
			qc.invalidateQueries({
				queryKey: ["club-portal", "clubs", clubId, "training"],
			}),
	});
}

export function useSetUserAvailability(clubId: string) {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: ({
			seasonId,
			userId,
			data,
		}: {
			seasonId: string;
			userId: string;
			data: SetAvailability;
		}) => clubApi.training.availability.setForUser(clubId, seasonId, userId, data),
		onSuccess: () =>
			qc.invalidateQueries({
				queryKey: ["club-portal", "clubs", clubId, "training"],
			}),
	});
}
